import { Typography } from '@mui/material'
import { PropsWithChildren } from 'react'

import { BaseLayout } from '@/components/layouts'
import { useRouter, useTranslation } from '@/core'
import { Cell, CellFrame, Template } from '@/core/architecture'

import {
  EmailVerificationForm,
  EmailVerificationFormProps,
} from './EmailVerificationForm'

export * from './fragments'

export type State = {
  verifyEmailSending: boolean
}

export type Action = {
  onSubmit: EmailVerificationFormProps['onSubmit']
  onResend: EmailVerificationFormProps['onResend']
}

export const EmailVerificationTemplate: Template<State, Action> = ({
  state,
  onSubmit,
  onResend,
}) => {
  return (
    <Layout>
      <EmailVerificationForm
        loading={state.verifyEmailSending}
        onSubmit={onSubmit}
        onResend={onResend}
      />
    </Layout>
  )
}

const Layout = ({ children }: PropsWithChildren<{}>) => {
  const { t } = useTranslation('mailAuth')
  const { routerPages } = useRouter()

  return (
    <BaseLayout
      margin
      header={{
        title: t('title'),
        back: true,
        defaultBackPage: routerPages.AccountSetting,
      }}
    >
      <TextCell />
      {children}
    </BaseLayout>
  )
}

const TextCell: Cell = () => {
  const { t } = useTranslation('mailAuth')

  return (
    <CellFrame
      sx={{
        py: 2,
      }}
    >
      <Typography variant="body2" color="text.primary">
        {t('description')}
      </Typography>
    </CellFrame>
  )
}
